export const TIPS = {
  LAYOUT: {
    HEADER: {
      PROFILE_ICON: { DATA: 'LAYOUT.HEADER.PROFILE_ICON', SELECTOR: '[data-tour="LAYOUT.HEADER.PROFILE_ICON"]' },
      TOUR_TIPS_BUTTON: {
        DATA: 'LAYOUT.HEADER.TOUR_TIPS_BUTTON',
        SELECTOR: '[data-tour="LAYOUT.HEADER.TOUR_TIPS_BUTTON"]',
      },
      PROFILE_ICON_DROPDOWN: {
        DATA: 'LAYOUT.HEADER.PROFILE_ICON_DROPDOWN',
        SELECTOR: '[data-tour="LAYOUT.HEADER.PROFILE_ICON_DROPDOWN"]',
      },
      ZONE_MENU: {
        DATA: 'LAYOUT.HEADER.ZONE_MENU',
        SELECTOR: '[data-tour="LAYOUT.HEADER.ZONE_MENU"]',
      },
    },
    SIDEBAR: {
      TOGGLE_BUTTON: {
        DATA: 'LAYOUT.SIDEBAR.TOGGLE_BUTTON',
        SELECTOR: '[data-tour="LAYOUT.SIDEBAR.TOGGLE_BUTTON"]',
      },
      MINI_SIDEBAR_INNOVATION_ECOSYSTEM: {
        DATA: 'LAYOUT.SIDEBAR.MINI_SIDEBAR_INNOVATION_ECOSYSTEM',
        SELECTOR: '[data-tour="LAYOUT.SIDEBAR.MINI_SIDEBAR_INNOVATION_ECOSYSTEM"]',
      },
      MINI_SIDEBAR_INNOVATION_MY_HUB: {
        DATA: 'LAYOUT.SIDEBAR.MINI_SIDEBAR_INNOVATION_MY_HUB',
        SELECTOR: '[data-tour="LAYOUT.SIDEBAR.MINI_SIDEBAR_INNOVATION_MY_HUB"]',
      },
      VERTICAL_MENU_CLOSE_ICON: {
        DATA: 'LAYOUT.SIDEBAR.VERTICAL_MENU_CLOSE_ICON',
        SELECTOR: '[data-tour="LAYOUT.SIDEBAR.VERTICAL_MENU_CLOSE_ICON"]',
      },
      MINI_SIDEBAR_TOP_SECTION: {
        DATA: 'LAYOUT.SIDEBAR.MINI_SIDEBAR_TOP_SECTION',
        SELECTOR: '[data-tour="LAYOUT.SIDEBAR.MINI_SIDEBAR_TOP_SECTION"]',
      },
      MINI_SIDEBAR_BOTTOM_SECTION: {
        DATA: 'LAYOUT.SIDEBAR.MINI_SIDEBAR_BOTTOM_SECTION',
        SELECTOR: '[data-tour="LAYOUT.SIDEBAR.MINI_SIDEBAR_BOTTOM_SECTION"]',
      },
    },
  },
  SMART_ZONE: {
    DATA_CONTACTS: {
      TABLE: {
        DATA: 'SMART_ZONE.DATA_CONTACTS.TABLE',
        SELECTOR: '[data-tour="SMART_ZONE.DATA_CONTACTS.TABLE"]',
      },
    },
  },
  SAT_V1_ZONE: {},
};
